import { HexToHueConverter } from '../../../../../../../helper/ColorToHueConverter';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

function AppBar_3({ customization }) {
  const staticValues = useSelector(state => state.themeSlice?.staticValues);

  const appBarFilter = useMemo(() => HexToHueConverter(customization?.textColor), [customization?.textColor]);
  return (
    <div className="flex flex-row w-full items-center relative gap-[7.5px]" style={{ height: staticValues[40] }}>
      {customization?.items?.map(appBarItem => {
        const isLogo = appBarItem?.id === 'logo';
        const logoAlignmentClass = isLogo ? 'w-full flex items-center ' : '';
        const logoClass = isLogo
          ? customization?.logoPosition === 'left'
            ? 'mr-auto'
            : customization?.logoPosition === 'right'
            ? 'ml-auto'
            : 'left-[50%] translate-x-[-50%] absolute'
          : 'max-h-[15.946px] max-w-[15.946px] 2xl:max-h-[20px] 2xl:max-w-[20px]';

        const logoStyle = isLogo ? { height: '40px', width: '100px', objectFit: 'contain' } : { filter: appBarFilter };

        return (
          <div className={logoAlignmentClass} key={appBarItem?.url}>
            <img style={logoStyle} className={logoClass} src={appBarItem?.url} alt={'bottom bar icon'} />
          </div>
        );
      })}
    </div>
  );
}

export default AppBar_3;
